import { Component, HostListener, OnInit, inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef } from 'ag-grid-community';
import { Router } from '@angular/router';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialog } from '../../shared/components/confirm-dialog/confirm-dialog';
// import { AppComponent } from '../../app.component';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { PaginationHelper } from '../../shared/services/pagination.service';
import { AccommodationService } from '../../features/accommodation/services/accommodation.service';
import { AllocateEmployeeDialog } from './allocate-employee/allocate-employee.component';
import { PermissionService } from '../../shared/services/permission.service';
import { ModuleIds } from '../../shared/permission-constants/permission-const';

@Component({
  selector: 'app-accommodation',
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    AgGridAngular,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
  ],
  templateUrl: './accommodation.component.html',
  styleUrl: './accommodation.component.scss',
})
export class AccommodationComponent implements OnInit {
  public viewPortSize: boolean = false;
  public rowData: any[] | null = null;
  public loading: boolean = true;
  public error: any = null;
  private searchSubject = new Subject<string>();
  readonly dialog = inject(MatDialog);
  startDate: any;
  endDate: any;
  dateRangeForm: FormGroup;
    canListAccommodation$ = this.permissionService.hasPermission(
      ModuleIds.Accommodation,
      'List'
    );
    canCreateAccommodation$ = this.permissionService.hasPermission(
      ModuleIds.Accommodation,
      'Create'
    );
  canEditAccommodation$ = this.permissionService.hasPermission(
      ModuleIds.Accommodation,
      'Edit'
    );
    canDeleteAccommodation$ = this.permissionService.hasPermission(
      ModuleIds.Accommodation,
      'Delete'
    );
    canAllocateAccommodation$ = this.permissionService.hasPermission(
      ModuleIds.Accommodation,
      'Allocate'
    );
    canRentSummaryAccommodation$ = this.permissionService.hasPermission(
      ModuleIds.Accommodation,
      'List Rent Summary'
    );
    canRentSummaryAccommodation: boolean = false;
    canAllocateAccommodation: boolean = false;
    canDeleteAccommodation: boolean = false;
    canEditAccommodation: boolean = false;

  dateFilter = (date: Date | null): boolean => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Remove time component
    return date ? date <= today : false;
  };

  columnDefs: (
    | {
        headerName: string;
        field: string;
        flex: number;
        valueFormatter?: undefined;
        cellRenderer?: undefined;
        floatingFilter?: undefined;
        filter?: undefined;
      }
    | {
        headerName: string;
        field: string;
        flex: number;
        valueFormatter: (params: any) => string;
        cellRenderer?: undefined;
        floatingFilter?: undefined;
        filter?: undefined;
      }
    | {
        field: string;
        headerName: string;
        flex: number;
        cellRenderer: (params: any) => HTMLDivElement;
        floatingFilter: boolean;
        filter: boolean;
        valueFormatter?: undefined;
      }
  )[];
  page = 0;
  pageSize = 10;
  totalPages = 1;
  pageSizeOptions = [5, 10, 20, 50, 100];
  public paginationPageSizeSelector: number[] | boolean = [10, 25, 50];

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkViewportSize();
  }

  checkViewportSize() {
    if (window.innerWidth > 1200) {
      this.viewPortSize = true;
    } else {
      this.viewPortSize = false;
    }
    this.setAGColumn();
  }

  setAGColumn() {
    this.columnDefs = [
      {
        headerName: 'Property Name',
        field: 'propertyName',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Address',
        field: 'address',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Annual Rent',
        field: 'annualRent',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Total Vacancies',
        field: 'vacancies',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Balance Vacancies',
        field: 'balanceVacancies',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        field: 'action',
        headerName: 'Actions',
        flex: this.viewPortSize ? 1 : 0,
        cellRenderer: (params: any) => {
          const container = document.createElement('div');
          container.style.display = 'flex';
          container.style.alignItems = 'center';
          container.style.gap = '20px';
          // console.log(params);

          const editIcon = document.createElement('img');
          editIcon.src = 'assets/images/icons/icon-edit.svg';
          editIcon.style.cursor = 'pointer';
          editIcon.setAttribute('data-action', 'edit');
          if(this.canEditAccommodation){
            container.appendChild(editIcon);
          }

          const deleteIcon = document.createElement('img');
          deleteIcon.src = 'assets/images/icons/icon-delete.svg';
          deleteIcon.style.cursor = 'pointer';
          deleteIcon.setAttribute('data-action', 'delete');
          if(this.canDeleteAccommodation){
          container.appendChild(deleteIcon);
          }

          const allocateIcon = document.createElement('img');
          allocateIcon.src = 'assets/images/icons/allocate-employee.svg';
          allocateIcon.style.cursor = 'pointer';
          allocateIcon.setAttribute('data-action', 'allocate');
          if(this.canAllocateAccommodation){
          container.appendChild(allocateIcon);   
          }
          const monthlyRent = document.createElement('img');
          monthlyRent.src = 'assets/images/icons/rent.svg';
          monthlyRent.style.cursor = 'pointer';
          monthlyRent.setAttribute('data-action', 'rent');
          if(this.canRentSummaryAccommodation){
            container.appendChild(monthlyRent);   
          }


          return container;
        },
        floatingFilter: false,
        filter: false,
      },
    ];
  }
  public defaultColDef: ColDef = {
    filter: 'agTextColumnFilter',
    floatingFilter: true,
  };
  public rowSelection: 'single' | 'multiple' = 'multiple';
  public paginationPageSize = 10;
  public themeClass: string = 'ag-theme-quartz';

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private accommodationService: AccommodationService,
    private datePipe: DatePipe,
    // private appComponent: AppComponent,
    private fb: FormBuilder,
    private permissionService: PermissionService
  ) {}

  ngOnInit(): void {
    this.getAllProperties();
    this.searchSubject
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe((searchTerm) => {
        this.getAllProperties(searchTerm);
      });

    this.checkViewportSize();

    this.dateRangeForm = this.fb.group({
      startDate: [''],
      endDate: [''],
      customerName: [''],
    });

    this.canEditAccommodation$.subscribe(val => {
      this.canEditAccommodation = val;
    });
    this.canDeleteAccommodation$.subscribe(val => {
      this.canDeleteAccommodation = val;
    });
    this.canAllocateAccommodation$.subscribe(val => {
      this.canAllocateAccommodation = val;
    });
    this.canRentSummaryAccommodation$.subscribe(val => {
      this.canRentSummaryAccommodation = val;
    });

    // this.appComponent.toggleSidebar();
  }

  onSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value;
    this.pageSize = 10;
    this.page = 0;
    this.searchSubject.next(searchTerm);
  }

  nextPage() {
    if (this.page + 1 < this.totalPages) {
      this.page++;
      this.getAllProperties('', this.pageSize);
    }
  }

  prevPage() {
    if (this.page > 0) {
      this.page--;
      this.getAllProperties('', this.pageSize);
    }
  }

  onPageSizeChange(event: Event): void {
    const newSize = Number((event.target as HTMLSelectElement).value);
    console.log('New Page Size:', newSize);
    this.pageSize = newSize;
    this.page = 0;
    this.getAllProperties('', this.pageSize);
  }

  onDateChange(event: any, type: string) {
    const formattedDate = this.datePipe.transform(event.value, 'yyyy-MM-dd');
    if (type === 'start') {
      this.startDate = formattedDate;
    } else if (type === 'end') {
      this.endDate = formattedDate;
    }
    if (this.startDate != null && this.endDate != null) {
      this.getAllProperties();
    }
  }

  getAllProperties(search: string = '', pageSize: number = 10) {
    this.loading = true;
    if (pageSize) {
      this.pageSize = pageSize;
    }
    const skip = this.page * this.pageSize;

    const input = {
      limit: this.pageSize,
      skip: skip,
      search: search,
      startDate: this.startDate,
      endDate: this.endDate,
    };

    this.accommodationService.findAllPropertiesWithPagination(input).subscribe({
      next: (data) => {
        this.totalPages = Math.ceil(
          (data?.total || data.properties?.length) / this.pageSize
        );

        this.rowData = data?.properties.map((property: any) => {
          return {
            id: property?.id,
            propertyName: property?.propertyName || '--',
            address: property?.address || '--',
            annualRent:
              property?.annualRent != null
                ? `AED ${Number(property.annualRent).toFixed(2)}`
                : '--',
            vacancies: property?.vacancies || '--',
            balanceVacancies: property?.balanceVacancies || '--',
          };
        });
        if (this.rowData) {
          this.paginationPageSizeSelector =
            PaginationHelper.getPaginationPageSizeOptions(this.rowData);
        } else {
          this.paginationPageSizeSelector = [];
        }
        this.loading = false;
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  openEdit(accommodationData: any) {
    const accommodationId = accommodationData?.id;
    if (accommodationId) {
      this.router.navigate([`/accommodation/edit/${accommodationId}`]);
    }
  }

  onDeleteAccommodation(accommodationData: any): void {
    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {
        title: 'Confirm delete',
        message: 'Are you sure you want to remove this property?',
        confirmText: 'Confirm',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.removeAccommodation(accommodationData?.id);
      }
    });
  }

  private removeAccommodation(accommodationId: number): void {
    this.accommodationService
      .removeProperty(Number(accommodationId))
      .subscribe({
        next: () => {
          this.toastr.success('Accommodation removed successfully.');
          this.getAllProperties();
        },
        error: (error) => {
          this.toastr.error(
            error.message || 'Failed to remove accommodation. Please try again.'
          );
        },
      });
  }

  onCellClicked(params: any) {
    if (
      params.column.colId === 'action' &&
      params.event.target.dataset.action
    ) {
      let action = params.event.target.dataset.action;

      if (action === 'edit') {
        this.openEdit(params?.data);
      } else if (action === 'delete') {
        this.onDeleteAccommodation(params?.data);
      } else if (action === 'allocate') {
        this.openEditDialog(params?.data);
      } else if (action === 'rent') {
        const id = params.data?.id;
        this.router.navigate([`accommodation/monthly-rent`], {
          queryParams: { accommodationId: id },
        });
      }
    } else {
      const id = params.data?.id;
      this.router.navigate([`accommodation/detail`], {
        queryParams: { accommodationId: id },
      });
    }
  }

  onClear() {
    this.startDate = null;
    this.endDate = null;
    this.dateRangeForm.reset();
    this.getAllProperties();
  }

  navigateTo(route: string) {
    this.router.navigate([route]);
  }

  // isDropdownOpen = false;

  // toggleDropdown(event?: MouseEvent) {
  //   if (event) {
  //     event.stopPropagation();
  //   }
  //   this.isDropdownOpen = !this.isDropdownOpen;
  // }

  // allocate employee dialog

  openEditDialog(propertyData: any) {
    const dialogRef = this.dialog.open(AllocateEmployeeDialog, {
      disableClose: true,
      data: {
        propertyData: propertyData,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'success') {
        this.getAllProperties();
      }
    });
  }
}
